export default {
  close: 'Close',
  dataIterator: {
    pageText: '{0}-{1} de {2}',
    noResultsText: 'Nenhum resultado encontrado',
    loadingText: 'Carregando itens...',
  },
  dataTable: {
    itemsPerPageText: 'Linhas por página:',
    ariaLabel: {
      sortDescending: ': Ordenado decrescente. Ative para remover a ordenação.',
      sortAscending: ': Ordenado crescente. Ative para ordenar decrescente.',
      sortNone: ': Não ordenado. Ative para ordenar crescente.',
    },
    sortBy: 'Ordenar por',
  },
  dataFooter: {
    itemsPerPageText: 'Itens por página:',
    itemsPerPageAll: 'Todos',
    nextPage: 'Próxima página',
    prevPage: 'Página anterior',
    firstPage: 'Primeira página',
    lastPage: 'Ultima página',
  },
  datePicker: {
    itemsSelected: '{0} Selecionar data',
  },
  noDataText: 'Não há dados',
  carousel: {
    prev: 'Visão anterior',
    next: 'Próxima visão',
  },
  calendar: {
    moreEvents: 'Mais {0}',
  },
  fileInput: {
    counter: '{0} arquivos',
    counterSize: '{0} arquivos ({1} no total)',
  },
  observation: {
    accumulatedTemperature: 'Temperatura acumulada eficaz',
    accumulatedTemperatureList: 'Lista de temperatura acumulada e eficaz',
    startDateCalculation: 'Data de início do cálculo',
    endDateCalculation: 'Data de fim da acumulação',
    lowerLimitTemperature: 'Temperatura limite inferior',
    registerAndEditAccumulatedTemperaturePoints: 'Registro/edição do ponto para o cálculo da temperatura acumulada',
    period: 'Período',
    accumulatedLowerLimitTemperature: 'Temperatura limite inferior acumulada',
    deleteAccumulatedTemperatureLocation:
      'Você tem certeza de que deseja excluir os pontos integrados de observação de temperatura de 「{fieldName}」?',
    soilMoisture: 'Umidade do solo',
    soilTemperature: 'temperatura do solo',
    precipitation: 'precipitação',
    soilMoistureList: 'Lista de umidade do solo',
    maxRegisterCount: '（Até {count} itens）',
    soilConditionVeryWet: 'Excesso de umidade',
    soilConditionWet: 'Úmido',
    soilConditionDry: 'Secura',
    soilConditionVeryDry: 'Secagem excessiva',
    drainage: 'Textura do solo',
    registerAndEditSoilMoisturePoints: 'Registro/edição dos pontos de cálculo da umidade do solo',
    soilMoistureConditionGood: 'Argila arenosa',
    soilMoistureConditionSlightlyBad: 'Argila argilosa',
    soilMoistureConditionBad: 'Argila',
    soilMoistureConditionSandyLoam: 'Argila arenosa',
    soilMoistureConditionClayLoam: 'Argila argilosa',
    soilMoistureConditionClay: 'Argila',
    deleteSoilMoistureLocation:
      'Você tem certeza de que quer apagar os pontos de observação de umidade do solo em「{fieldName}」?',
    deletedField: '< O talhão foi removido >',
    validateForStartDateBeforeYesterday: 'A data de início deve ser, pelo menos, um dia antes',
    validateForStartEndDateOrder: 'A data final deve ser posterior à data de início',
    validateForStartEndDuration: 'As datas de início e fim devem estar dentro de dias {day} um do outro',
    validateForStartNowDuration: 'A data de início deve ser dentro de {day} dias após o presente',
  },
  caster: {
    rtkInfo: 'Informação de correcção RTK',
    rtkLog: 'Diário de comunicação',
    myBaseStationStatus: 'Estado da minha estação base',
    howToSetupRtkBase: 'Ao enviar informação de correcção do produto de outra empresa para "A Minha Estação Base".',
    howToSetupRtkRover: 'Ao receber informação de correcção da "Minha Estação Base" com o produto de outra empresa',
    host: 'Host',
    port: 'Porto',
    mountpoint: 'Ponto de Montagem',
    derivedPassthroughLabel: ' (sem conversão)',
    derivedPassthroughCaption: 'Transmite as correções da estação base sem alterações. Opção habitual',
    derivedMsm4Label: ' (compatibilidade)',
    derivedMsm4Caption: 'Convertido para MSM4: para receptores instáveis com o formato mais recente (ex. MSM7)',
    derivedLegacyLabel: ' (para receptores antigos)',
    derivedLegacyCaption: 'Convertido para o formato legado 1004/1012: apenas GPS+GLONASS',
    derivedNote:
      'Se as correções não forem recebidas ou não houver FIX, tente _MSM4 / _LEGACY. Essas saídas podem não estar disponíveis com uma estação base que não seja AgriBus.',
    messageTypesTitle: 'Tipos de mensagens transmitidas (detalhes técnicos)',
    messageTypesIntro:
      'Se um fabricante de receptores perguntar quais mensagens RTCM a estação base transmite, informe a lista abaixo conforme o ponto de montagem utilizado.',
    messageTypesPassthrough:
      'Transmite a saída da estação base sem alterações. Para nossas estações base AgriBus-GMiniR: RTCM 3.3 / MSM4+MSM7 (1074/1077 GPS, 1084/1087 GLONASS, 1094/1097 Galileo, 1124/1127 BeiDou) a cada segundo, mais 1005 (posição da estação), 1008 (informações da antena) e 1230 (vieses código-fase GLONASS). Com estações base de outros fabricantes, depende da configuração do equipamento',
    messageTypesMsm4:
      'Normalizado para RTCM 3.3 / MSM4: 1074 (GPS), 1084 (GLONASS), 1094 (Galileo), 1114 (QZSS), 1124 (BeiDou) a cada segundo (somente as constelações recebidas pela estação base), mais 1006, 1033 e 1230 a cada 5 segundos',
    messageTypesLegacy:
      'Formato antigo (estilo RTCM 3.1): 1004 (GPS L1/L2) e 1012 (GLONASS L1/L2) a cada segundo, mais 1006 e 1008 a cada 5 segundos (sem 1033/1230). Os registros de tempo das observações são alinhados a segundos inteiros, permitindo o uso de receptores que esperam esse formato',
    baseStation: 'Estação Base',
    rover: 'Rover',
    userId: 'ID do utilizador',
    ntripUserId: 'Ntrip ID do utilizador',
    ntripPassword: 'Ntrip palavra-passe',
    showCaption: 'Mostrar',
    statusTab: 'Status',
    qualityTab: 'Qualidade',
    mapTab: 'Mapa',
    logTab: 'Registro de conexões',
    settingsTab: 'Configurações',
    baseShort: 'Estação base',
    casterServer: 'Servidor caster',
    roverShort: 'Rover',
    receiving: 'Recebendo',
    stale: 'Recepção parada',
    noConnection: 'Não conectado',
    lastReceivedAt: 'Última recepção',
    disconnectedAt: 'Desconectado',
    summaryTitle: 'Recepção da estação base',
    lastSnapshotNote: 'Últimos valores antes da desconexão',
    noStatsData: 'Nenhum dado recebido da estação base',
    bytesRate: 'Taxa de dados',
    messagesPerSecond: 'Mensagens',
    epochInterval: 'Intervalo de época',
    uptime: 'Tempo conectado',
    decodeErrors: 'Erros de decodificação',
    basePosition: 'Posição da base',
    antenna: 'Antena',
    satellites: 'Satélites',
    signals: 'Sinais',
    meanCnr: 'C/N0 médio',
    msgType: 'Mensagem',
    msgCount: 'Contagem',
    msgInterval: 'Intervalo',
    msgLastSeen: 'Última recepção',
    cnrChart: 'C/N0 médio (dB-Hz)',
    satsChart: 'Satélites',
    rateChart: 'Taxa de dados (bytes/s)',
    epochChart: 'Intervalo de época (ms)',
    noHistoryData: 'Ainda não há dados de histórico',
    noTrackData: 'Sem registros GGA do rover',
    baseline: 'Linha de base',
    fixQuality: 'Qualidade do fix',
    ggaPoints: 'Pontos registrados',
    logBaseTitle: 'Conexões da estação base',
    logRoverTitle: 'Conexões de rovers',
    startAt: 'Início',
    endAt: 'Fim',
    inSession: 'Conectado',
    userAgentLabel: 'Cliente',
    logNote: 'Mostra registros das últimas 24 horas',
  },
  print: {
    field: {
      fillSetting: 'Preencha o talhão',
      backgroundWhiteColorSetting: 'Fundo branco',
      backgroundNoColorSetting: 'Sem antecedentes',
      printText: 'Impressão',
      showFieldName: 'Mostrar nome do talhão',
    },
  },
  sortOptions: {
    title: 'Ordenar por',
    field: {
      name: 'Nome do talhão',
      createdAt: 'Data de registro',
      lastModifiedDateTime: 'Data modificada',
    },
  },
  fieldElevation: {
    title: 'elevação',
    cantBuildBecauseNoTask: 'A história do trabalho não existe, pelo que não é possível criar um mapa em altura.',
    nowBuilding: 'A preparar... (Dependendo da área do talhão, pode demorar algum tempo a criar).',
    updatedAt: 'Data de criação',
    meshSize: 'Tamanho da malha',
    taskFetchLimit: 'volume de dados',
    taskDateRange: 'Âmbito',
    taskPointCount: 'contagem dos pontos de trabalho',
    editButton: 'Editar',
    createButton: 'Criar',
    needStandardPlan: 'O Mapa de Altura requer o Plano Padrão.',
    taskFetchLimitHint: 'Se não houver diferença na altura, aumente-a. Se houver muito ruído, reduza-o.',
    creationFailedMessage: 'A criação do Mapa de Altura falhou.',
    gnssStatus: 'GNSS estatuto',
    ElevationRange: 'Alcance de Elevação',
    optionSetting: 'Definição de opções',
    minValue: 'Valor mínimo',
    maxValue: 'Valor máximo',
    minIgnoreCaption: 'As elevações abaixo deste valor são ignoradas',
    maxIgnoreCaption: 'Elevações acima deste valor serão ignoradas',
    minValueNeedError: 'Por favor, defina um valor mínimo',
    maxValueNeedError: 'Por favor, defina o valor máximo',
    minValueRangeError: 'O valor mínimo deve ser inferior ao valor máximo',
    maxValueRangeError: 'O valor máximo deve ser superior ao valor mínimo',
    invalidOptionSettingError: 'Invalid option setting specified',
    dateRangeInput: 'Intervalo de datas',
    oldestTaskDateInput: 'Data de início',
    newestTaskDateInput: 'Data final',
  },

  navi: {
    GeneralMainSettingMenuGnssSource: 'Fonte GNSS',
    GeneralMainSettingGnssSourceInternal: 'Internal',
    GeneralMainSettingGnssSourceGPlus: 'AgriBus-G+',
    GeneralMainSettingGnssSourceG2: 'AgriBus-G2',
    GeneralMainSettingGnssSourceGMini: 'AgriBus-GMini',
    GeneralMainSettingGnssSourceGMiniR: 'AgriBus-GMiniR',
    GeneralMainSettingGnssSourceUsb: 'USB',
    GeneralMainSettingGnssSourceBluetooth: 'Bluetooth',
    GeneralMainSettingGnssSourceTcpPort: 'Porta TCP',
    GeneralMainSettingGnssSourceNtripClient: 'Cliente Ntrip (Trimble, Topcon)',
    GeneralMainSettingGnssSourceVirtual: 'Virtual',
  },

  ValidationTextRequired: 'Preenchimento obrigatório',
  ResetPasswordTitle: 'Redefinir e reemitir a senha',
  ResetPasswordButton: 'Redefinir a senha',
  ResetPasswordDescription:
    'Você receberá um email contendo um link de redefinição/reemissão de senha. Favor redefinir a senha conforme a orientação no email.',
  ValidationBadEmail: 'Endereço de email inválido',
  ChangePasswordButton: 'Alterar a senha',
  CreatePasswordButton: 'Crie uma senha',
  UnitTitle: 'Unidade',
  UnitMetric: 'Métrica',
  UnitImperial: 'Imperial',
  UnitJpUnitsOfArea: 'Unidades de área japonesas',
  UnitThUnitsOfArea: 'Unidades de área tailandesas',
  NickNameHint: 'Seu apelido',
  SendMeNews: 'Receber notícias no seu email',
  FreePlanDisplayName: 'Plano gratuito',
  StandardPlanDisplayName: 'Plano Padrão',
  ChangePasswordTitle: 'Alterar a senha',
  CreatePasswordTitle: 'Criar senha',
  CurrentPasswordHint: 'Senha atual',
  NewPasswordHint: 'Nova senha',
  SignInButton: 'Entrar',
  ToResetPasswordButton: 'Esqueceu a senha ?',
  DocFormFieldDetailFieldNameHint: 'Nome do talhão',
  DocFormTaskRecordDetailFieldNameHint: 'Nome do registro de trabalho',
  DocFormTaskRecordDetailDescriptionHint: 'Descrição',
  DocFormTabNameTaskRecordList: 'Registros de trabalho',
  DocFormTabNameRefLineList: 'Linhas de orientaçao',
  DocFormTabNameGridPointsList: 'Dados de grade',
  DocFormTabNameFieldList: 'Talhões',
  DocFormFieldRegisteredDateFormatBase: 'Data do registro: {createDate}',
  DocFormMenuItemSignOut: 'Sair',
  DocFormFieldDetailDescriptionHint: 'Descrição',
  StandardPlanIsNeededDialogMessage:
    'Este recusro é disponível para o assinante de Plano Padrão (teste gratuitamente por 30 dias !).',
  SelectPlanDialogTitle: 'Selecione um plano',
  SelectPlanDialogRecommend: 'Recomendado',
  SelectPlanDialogYearPlan: 'Plano anual',
  SelectPlanDialogYearPlanGreatValue: '(Com 2 meses de desconto)',
  SelectPlanDialogYearMonth: 'Plano mensal',
  StandardPlanPriceForMonthBatch: 'Total em um ano',
  StandardPlanPricePerMonth: '/ Mês',
  StandardPlanPricePerYear: '/ Ano',
  StandardPlanPriceForYearNotice: '* Pagamento por 12 meses',
  SelectPlanSubscribeYear: 'Teste por 30 dias',
  SelectPlanSubscribeMonth: 'Iniciar teste de 30 dias',
  selectPlanDataViewNote:
    '* Se você não retomar sua assinatura em aproximadamente um mês após o cancelamento, os dados registrados antes do cancelamento deixarão de ser exibidos (aplicável a partir de 1º de outubro de 2026). Exporte os dados de que necessitar enquanto sua assinatura estiver ativa.',
  DefaultRefLineTypeStraight: 'Linha reta',
  DefaultRefLineTypeCurved: 'Linha curva',

  customSelectAll: 'Selecionar tudo',
  customUnSelectAll: 'Cancelar a seleção',
  customRegistration: 'Cadastrar',
  customUpdate: 'Atualizar',
  customSearch: 'Pesquisar',
  customDelete: 'Excluir',
  customAllow: 'Aprovar',
  customDeny: 'Declinar',
  customDefault: 'Padrão',
  customSelected: 'Selecionado',
  customSelectThis: 'Selecionar',
  customArea: 'Área',
  customNotAvailable: 'Indisponível',
  customEdit: 'Editar',
  customCancel: 'Cancelar',
  customNone: 'None',
  customClose: 'Fechar',
  customFieldDrawHint:
    'Clique no mapa para adicionar vertices e confirme com o botao de verificacao (botao desfazer / Backspace remove o ultimo ponto)',
  customBack: 'Voltar',
  customRefresh: 'Recarregar',
  customUpload: 'Atualizar',
  customPriceIncludingTax: 'Valor (imposto incluso)',
  customPay: 'Efetuar pagamento',
  customCancelContract: 'Cancelar a assinatura',
  customConfirmReally: 'Realmente deseja prosseguir ?',
  customRememberMe: 'Salvar',
  customLogin: 'Login',
  customNowLoggingIn: 'Fazendo login...',
  customEmail: 'Endereço de e-mail',
  customPassword: 'Senha',
  customUser: 'Usuário',
  customUserSettings: 'Configração de usuário',
  customSentEMailMessage: 'E-mail enviada.',
  customNewPasswordReInput: 'Redigitar nova senha',
  customValidationPasswordMinLength: 'A senha deve conter pelo menos {length} caracteres',
  customValidationPasswordMaxLength: 'A senha deve ser com menos caracteres',
  customValidationPasswordNotMatch: 'A senha não corresponde',
  customChangePasswordSuccess: 'A senha foi alterada',
  customGoToLoginPageTitle: 'Retornar para a tela de login',
  customYouDontHaveAccount: 'Se você ainda não tem a conta',
  customRegisterAgriBusWeb: 'Inscreva-se AgriBus-Web',
  customChange: 'Alterar',
  customLanguage: 'Language',
  customSaveAction: 'Salvar',
  customSaveSuccess: 'Salvo',
  customAddAction: 'Adicionar',
  customPlan: 'Plano',
  customPlanExpirationDate: 'Valido até: {expirationDate}',
  customPlanDescription: 'A alteração do plano deve ser feita no aplicativo Android (AgriBus-NAVI).',
  customPlanOnly: 'Este recurso é exclusivo no Plano Padrão',
  customDetail: 'Detalhes',
  customDatePickerNullAlert: 'Selecione a data primeiro',
  customTaskNotFound: 'Histórico de trabalho não encontrado',
  customTaskNotFoundAtDate: 'Histórico de trabalho não encontrado. Data de trabalho: {date}',
  customErrorInitTasksFreePlan: 'No plano gratuito, o período do histórico é limitado em até dois dias',
  customErrorInitTasksNoTasks: 'Se nada for exibido, execute "Sincronização de dados" no AgriBus-NAVI',
  customErrorInitFieldsNoFields:
    'Nenhum talhão está registrado, ou não foi executado "Sincronização de dados" no AgriBus-NAVI',
  customColored: 'Codificação por cor',
  customHeight: 'Altitude',
  customHeightMap: 'Mapa de altitude',
  customSpeed: 'Velocidade',
  customDate: 'Data e hora',
  customWorkWidth: 'Largura de trabalho',
  customWorkedArea: 'Área trabalhado',
  customOverlappedArea: 'Área sobreposta',
  customTaskRecordEfficiency: 'Eficiência',
  customDistance: 'Kilometragem',
  customWorkedTime: 'Hora trabalhada',
  customAverageSpeed: 'Velocidade média',
  customWorker: 'Trabalhador',
  customDocFormTaskRecordDistanceOfFormatBase: '{distance} (médio {speed})',
  customDocFormTaskRecordWorkedAreaPercentageFormatBase: '{percentage}% de {fieldArea}',
  customDocFormTaskRecordWorkedAreaInfoFormatBase: '{areaPercentageText}, {efficiencyText}/h',
  customPageSuffix: 'Página',
  customDisplayCount: 'Número de itens exibidos',
  customTotalCount: 'Total de {count}',
  customListingModeSelf: 'Somente o seu',
  customListingModeAll: 'Incluir seguidores',
  customIconSettings: 'Configuração de ícone',
  customAccountHeader: 'Conta',
  customConnectionHeader: 'Conexões',
  customConnectionTitle: 'Conexões',
  customFollowRequest: 'Follow Request',
  customSendFollowRequestMessage: 'Uma solicitação para seguir foi enviada',
  customFollow: 'Seguir',
  customUnfollow: 'Deixar de seguir',
  customFollowing: 'Seguindo',
  customFollower: 'Seguidor',
  customHaveNoFollowings: 'Está seguindo ninguém',
  customHaveNoFollowers: 'Sem seguidor',
  customInbox: 'Receber',
  customOutbox: 'Enviar',
  customInboxEmpty: 'Não há solicitação para seguir recebida',
  customOutboxEmpty: 'Não há solicitação para seguir enviada',
  customSendFollowRequest: 'Enviar solicitação para seguir',
  customFollowRequestSelfRequestError: 'Não é possível enviar solicitações para seguir para você mesmo',
  customAllowFollowRequest: 'Aceito a solicitaçao para seguir {fromNickname}',
  customUnfollowMessage: 'Deixou de seguir',
  customUpdatedIconMessage: 'Ícone alterado',
  customIconNowSelected: 'Selecionado',
  customIcon: 'ícone padrão',
  customIconSettingsDescription: 'Recomendamos que você defina seu próprio ícone.',
  customIconChangeToIcon: 'Alterar para a predefinição',
  customGravatarIcon: 'Gravatar',
  customIconSettingsGravatarDescription: 'Se você tiver o ícone no Gravatar, será útil escolher esta opção.',
  customIconChangeToGravatar: 'Alterar para Gravatar',
  customCustomIcon: 'Personalizar',
  customIconSettingsCustomDescription: 'Você pode configrar com suas fotos favoritas em arquivos JPEG ou PNG.',
  customIconChangeToCustom: 'Alterar para personalizado',
  customIconReUpload: 'Carregar novamente',
  customTemperature: 'Temperatura',
  customHumidity: 'Humidade',
  customWind: 'Velocidade do vento',
  customPressure: 'Pressão',
  customSunrise: 'Nascer do sol',
  customSunset: 'Pôr do sol',
  customShowAllCropsDescription: 'Mostrar tudo',
  customShowCurrentCropsDescription: 'Mostrar apenas os cultivos atuais',
  customProduct: 'Produto',
  customProductsNotFound: 'Não foi possível encontrar um produto',
  customColor: 'Cor',
  customYear: 'Ano',
  customCrop: 'Cultivo',
  customCropVariety: 'Variedade do cultivo',
  customDeleteCropConfirmationMessage:
    'Deseja excluir {cropYear} {cropName} {cropVariety} ? (Os dados associados também serão excluídos)',
  customOperationType: 'Trabalho',
  customFilter: 'Filtro',
  customOutOfField: 'Fora do talhão',
  customBillingAndPayment: 'Taxa/Pagamento',
  customBillingMethod: 'Forma de pagamento',
  customBillingExistingCard: 'Cartões registrados',
  customBillingAddNewCard: 'Adicionar novos cartões',
  customBillingMethodConfirm: 'Confere a forma do pagamento',
  customBillingHistory: 'Extrato de pagamento',
  customCreditCard: 'Cartão de crédito',
  customCreditCardLast4: 'Ultimos quatro dígitos',
  customCreditCardNameOnCard: 'Nome impresso no cartão',
  customCreditCardInfo: 'Dados do cartão',
  customCreditCardAddCard: 'Adicionar cartão',
  customCreditCardAddCardCaution1:
    'Desta vez, não há a cobrança para este cartão, mas o mesmo é definido como o cartão padrão para os próximos pagamentos.',
  customCreditCardAddCardCaution2:
    'Se você deseja pagar sua conta, entre em contato contact@agri-info-design.com antes de registrar seu cartão.',
  customCreditCardNoCard: 'Não há cartão de crédito cadastrado',
  customCreditCardDeleteFailure: 'Falha no cancelamento do registro do cartão',
  customMyProducts: 'Meus produtos',
  customMyProductsList: 'Lista de produtos',
  customMyProductProduct: 'Produto',
  customMyProductProductNumber: 'Número do produto',
  customMyProductDataPlan: 'Plano de dados',
  customMyProductDataPlanSubscribe: 'Contratar plano de dados',
  customMyProductDataPlanSubscribeSuccessMessage: 'Em breve a comunicação 3G do {productNumber} será ativada.',
  customMyProductDataPlanExpiredMessage: 'Expirado em {expiredDate}.',
  customMyProductDataPlanCancelConfirmationMessage:
    'Se você cancelar o contrato, a comunicação 3G será desativada. Os dias remanecentes do contrato não podem ser reembolsados. No entanto, mesmo que o contrato seja uma vez cancelado, é possível assinar novamente. Deseja cancelar ?',
  customRealTime: 'Tempo real',
  customRealTimeSettings: 'Configurações de tempo real',
  customModel: 'Modelo',
  customSystemVersion: 'Versão do sistema',
  customWebMarkerIcon: 'Ícone',
  customWebMarkerSetting: 'Configuração de marcador',
  customWebMarkerName: 'Nome do marcador',
  customWebMarkerColor: 'Cor do marcador',
  customRealtimeChooseYourDevice: 'Selecione o dispositivo',
  customRealtimeDeviceNotActive: 'Não está ativado',
  customElevation: 'Altitude',
  customGnss: 'GNSS',
  customSatellites: 'Satélite',
  customFirmwareVersion: 'Versão de firmware',
  customHasFirmwareUpdate: 'Existe versão atualizada',
  customFirmwareDownloadMessage: 'Nova versão {newestFirmwareVersion} está disponível.',
  customDownload: 'Download',
  customFieldRegistration: 'Registro de novo talhão',
  customFieldCreateWithMapTitle: 'Criar talhão no mapa',
  customFieldCreateWithMapTitleDescription: 'Crie um novo talhão no mapa',
  customFieldCreateWithMapButton: 'Criar',
  customFieldCreateWithMapFieldName: 'Nome do talhão',
  customFieldCreateWithMapLoadingMap: 'Carregando o mapa',
  customFieldCreateWithMapCreate: 'Criar',
  customFieldCreateWithMapCreateFinishedMessage: 'Talhão {fieldName} criado',
  customFieldCreateWithMapCreateErrorMessage: 'Falha ao criar o talhão {fieldName}',
  customFieldCreateWithMapNoFieldMessage: 'Crie um talhão no mapa',
  customFieldCreateWithMapNoFieldNameMessage: 'Digite o nome do talhão',
  customFieldCreateWithMapTooManyFieldsMessage: 'Pode ser criado apenas um talhão',
  customFieldUploadTitle: 'KML/Shapefile upload',
  customFieldUploadMessage: 'Carregue seus arquivos KML/KMZ ou Shapefile',
  customFileUploadShapefileDescription:
    'Sh​apefile​ requer um arquivo ZIP (compactado) contendo os seguintes arquivos.',
  customFieldUploadFileInput: 'Selecione o arquivo.',
  customFileUploadShpDescription: '.shp (Informação do terreno)',
  customFileUploadShxDescription: '.shx (Informação de indexação)',
  customFileUploadDbfDescription: '.dbf (Informação do atributo)',
  customFileUploadPrjDescription: '.prj (Informação de coordenadas geográficas)',
  customFileUploadPrjCaution: '.prj é necessário para a leitura das informações de coordenadas corretamente.',
  customFileUploadTextEncodingDescription: 'Alterar quando os atributos não forem exibidos corretamente',
  customFileUploadAttributeNameForFieldName: 'Nome do atributo usado como nome do talhão',
  customFileUploadFieldImportStart: 'Importação dos {count} talhões foi iniciada.',
  customFileUploadImportCheckTitle: 'Importar',
  customFileUploadFieldImportStartedMessage:
    'A importação dos talhões foi iniciada. Se a quantidade for grande, o processamento poderá levar alguns minutos.',
  customFieldUploadErrorMessage: 'Não é possível importar arquivos carregados.',
  customFieldThisFieldName: 'Talhão "{fieldName}"',
  customFieldUnknownFieldName: 'Este talhão',
  customFieldNoName: 'Nenhum talhão',
  customFieldDeleteAlertWithTask:
    'Encontrado(s) {count} histórico(s) do {fieldName}. Se exclui-lós, as informações do talhão nestes históricos de trabalho serão perdidas. Deseja prosseguir ?',
  customFieldDeleteAlertWithoutTask: 'Deseja excluir o {fieldName}？',
  customTextEncoding: 'Codificação',
  customFieldImportFinishedMessage: ' {count} talhões importados com sucesso.',
  customFieldImportErrorMessage: 'Falha na importação do talhão',
  customFieldCount: 'Quantidade de talhões: {count}',
  customExport: 'Exportação',
  customTaskExport: 'Exportar histórico de trabalho',
  customTaskWhatIsAgriBusFormat:
    'O formato AgriBus é um texto delimitado por tabulação, por isso é fácil de processar.',
  customTaskNowDeveloping: 'Em desenvolvimento',
  customTaskNowDevelopingDescription: 'Em breve você poderá exportar em outros formatos.',
  customTaskStartExporting: 'Começão a exportar',
  customTaskNowExporting: 'Exportando...',
  customTaskDownloadReady: 'Pronto para baixar',
  customFieldHeader: 'Talhão',
  customDarkMode: 'Modo escuro',
  customNewRegistration: 'Novo registro',
  customCreateNew: 'Criar',
  customImport: 'Importar',
  customListDisplay: 'Exibição em lista',
  customCardDisplay: 'Exibição em cartões',
  customCalendarDisplay: 'Exibir de calendário',
  customFieldsList: 'Lista de talhões',
  customPleaseSignUpFromAndroidApplication:
    'Inscreva-se pelo apricativo Android <span class="aid-logotype">AgriBus-NAVI</span>',
  customWhatIsAgribusNAVI: 'O que é <span class="aid-logotype">AgriBus-NAVI</span>',
  customAgriBusNAVIDescription:
    '<span class="aid-logotype">AgriBus-NAVI</span> é um aplicativo de orientação GPS (orientação GNSS) para Android OS destinados a máquinas agrícolas e veículos, como tratores, colheitadeiras e pulverizadores autopropelidos, para auxiliar as operações agrícolas convencionais. Instale no seu tablet ou smartphone e dirije verificando a tela do dispositivopara trabalho em linha reta e com intervalos iguais em um talhão grande.',
  customProductDetails: 'Veja os detalhes sobre o produto',
  aid: {
    calendar: {
      month: 'Month',
      week: 'Week',
      day: 'Day',
      fourDays: '4 days',
    },
  },
  customTaskFilterAllSelect: 'Todo o trabalho',
  customTaskFilterGetError: 'Falha ao obter informações do filtro',
  customTaskFilterPostError: 'Falha ao registrar as informações do filtro',
  customTaskFilterPutError: 'Falha na atualização das informações do filtro',
  customTaskFilterDeleteError: 'Falha ao excluir informações do filtro',
  customTaskFilterPostSucceed: '"{filtername}" registado',
  customTaskFilterPutSucceed: '"{filtername}" atualizado',
  customTaskFilterSetDefault: 'Definir "{filtername}" como o filtro padrão',
  customTaskFilterDeleteSucceed: 'Os dados do filtro foram excluídos',
  customTaskFilterSelectCheckError: 'O filtro selecionado não existe. Selecione um outro filtro',
  customTaskFilterDuplicateCheckError: 'Nome do filtro duplicado',
  customTaskFilterNotEnteredCheckError: 'Nenhum nome de filtro digitado',
  customTaskFilterStringNarrowing: 'Filtragem de string',
  customTaskFilterMakeDefault: 'Utilizar sempre este filtro',
  customTaskFilterName: 'Nome do filtro',
  customTaskFilterDeleteMsg: ' Deseja excluir "{filtername}" ?',
  customTaskFilterDialogTitle1: 'Filtrar histórico de trabalho',
  customTaskFilterDialogTitle2: 'Aplicar configurações de filtro salvas',
  customTaskFilterCreateNew: 'Crie uma nova configuração de filtro',
  customTaskFilterEdit: 'Edição de um filtro',
  customTaskFilterSetting: 'Configuração do filtro',
  customTaskFilterCurrent: 'Filtro de corrente',
  customTaskFilterNoTasksError: 'Devido à configuração do filtro "{filtername}", o número de itens apresentados é 0.',
  customTaskFilterAreaZeroHidden: 'Excluindo o trabalho com área de trabalho zero',
  customTaskFilterDistanceUnderTenHidden: 'Exclui trabalho com menos de 10m (10.936yd) de quilometragem',
  customTaskFilterNoField: 'Nenhum talhão',
  customTaskFilterNoCrop: 'Sem cultura',
  customTaskFilterOutOfFieldHidden: 'Exclui o histórico de tarefas fora do talhão',
  customSimpleSignUpNow: 'Registrando...',
  customSimpleSignUpSuccess: 'Um e-mail foi enviado para concluir o registro. Verifique sua caixa de e-mail',
  customEnterpriseInviteSuccess: 'Enviei-lhe um convite por e-mail',
  customSimpleSignUpFailed: 'Falha no registro',
  customSimpleSignUpUserAlreadyExists: 'Há um problema no seu endereço de e-mail',
  customSimpleSignUpServerError: 'Ocorreu um erro durante o processo de registro',
  customDateFilterStartDate: 'Data de início do filtro',
  customDateFilterEndDate: 'Data de término do filtro',
  customDateFilterCalendarType: 'Tipo de calendário',
  customDateFilterCalendarTypeDate: 'Dia',
  customDateFilterCalendarTypeMonth: 'Mês',
  customDateFilterSetBotton: 'Definir',
  customDateFilterRangeError:
    'A data de início é posterior à data de término. Por favor, selecione uma data novamente.',
  customCurrency: 'Moeda',
  customBillingCurrencyJPY: 'Iene Japonês',
  customBillingCurrencyUSD: 'dólar americano',
  customBillingPurchase: 'Faça o teste gratuito por 30 dias',
  customBillingPurchaseWithoutTrial: 'Upgrade',
  customBillingPlanInfo: 'Planejar informações',
  customBillingNowPlan: 'Seu plano',
  customBillingTrial: 'Julgamento',
  customBillingCancellation: 'Cancelamento',
  customBillingContractPeriod: 'Período do contrato',
  customBillingAmount: 'Montante',
  customBillingAlertMustRegisterCard: 'Para comprar, você precisa registrar um cartão de crédito com antecedência.',
  customBillingMessageUnsubscribe: 'Plano pago cancelado.',
  customBillingMessageSubscribe: 'Obrigado por sua compra',
  customBillingMessageUnSubscribeGoogle:
    'No momento, você está pagando no Google Play Store. Cancele no Google Play Store.',
  customBillingReceipt: 'Faturas / recibos',
  customBillingMessageCancelStandardPlan:
    'Se você cancelar seu plano pago, você ainda poderá utilizar o serviço pelo período pelo qual pagou. Se eu cancelar aqui, estarei automaticamente no plano livre após {data}, isto ainda é correto?',
  customBillingMessageCancelTrial:
    'Você está atualmente no período experimental, mas se você cancelar aqui, voltará imediatamente ao plano gratuito. Observe que você pode se inscrever para um novo plano pago após o cancelamento, caso em que o período experimental não se aplicará mais.',
  customBillingStandardDescription:
    'Um mês gratuito com um plano anual pago; tire proveito de todas as características, incluindo o armazenamento de dados indefinido da AgriBus-Web e exibição da posição do veículo em tempo real, a guia de curvas e bandeja de informações da AgriBus-NAVI!',
  customBillingMenu: 'Gerenciamento do plano de uso',
  customBillingMore: 'Saiba mais',
  customAdRow1_1: 'Revolucione os dados do trabalho agrícola',
  customAdRow1_2: 'usando o Plano Padrão',
  customAdRow2_1: 'Três benefícios',
  customAdRow2_2: 'Armazenamento e exportação ilimitados de dados',
  customAdRow2_3: 'Exibição em tempo real da posição do veículo',
  customAdRow2_4: 'Uso do AgriBus-Caster',
  customAdRow3_1: 'Três benefícios',
  customAdRow3_2: 'Adicione diferença de altura, velocidade de execução, etc. à faixa de trabalho',
  customAdRow3_3: 'Salvar e recuperar a linha de base da orientação',
  customAdRow3_4: 'Aplicar orientação de curva',
  customOAuthMessage: 'Durante a autenticação...',
  customGoogleOAuthBtn: 'Entre com o Google',
  customGoogleOAuthSignUpBtn: 'Inscreva-se no Google',
  customOAuthError: 'Erro no processo de autenticação OAuth',
  customOAuthGetUserInfoError: 'Ocorreu um erro ao obter informações do OAuth',
  customOAuthServerError: 'Ocorreu um erro no processo de registro de credenciais do OAuth',
  customOAuthFailed: 'Falha na autenticação OAuth',
  customToBillingPage: 'Para a tela de compra do plano standard',
  customTasksListFreePlanMsg:
    'No plano gratuito, o histórico de trabalho é exibido apenas por 2 dias. Ao assinar o Plano Padrão, você pode ter um período de armazenamento ilimitado.',
  customEnterprise: 'Empresa',
  customEnterpriseSetting: 'Configurações da empresa',
  customEnterpriseManagement: 'Gestão Empresarial',
  customWhatIsEnterprise: 'O que é a AgriBus-Web Enterprise?',
  customEnterpriseRegistration: 'Inscrever-se no Plano Empresarial',
  customPleaseContinueToRegisterForEnterprise:
    'Por favor, continue o processo de registro para AgriBus-Web Enterprise a partir do e-mail que você recebeu.',
  customPleaseInputOrganizationName: 'Por favor, digite o nome de sua organização.',
  customEnterpriseName: 'Nome da empresa',
  customMaxOfMemberThisMonth: 'Número máximo de membros este mês',
  customExpectedPaymentAmountForThisMonth: 'Valor do pagamento estimado para este mês',
  customDateOfPayment: 'Data do pagamento',
  customPaymentHistory: 'Histórico de pagamentos',
  customEditEnterpriseName: 'Editar nome da empresa',
  customOrganization: 'Organização',
  customOrganizationName: 'Nome da organização',
  customAdministrator: 'Administrador',
  customOrganizationList: 'Organograma',
  customNewOrganization: 'Criando uma nova organização',
  customCreateOrganization: 'Criar uma organização',
  customEditOrganizationName: 'Editar nome da organização',
  customTeam: 'Equipe',
  customTeamList: 'Lista de Equipe',
  customMyTeam: 'A minha equipa',
  customMyTeamList: 'Lista da minha equipa',
  customNewTeam: 'Criando uma nova equipe',
  customTeamName: 'Nome da equipe',
  customCreateTeam: 'Criar uma equipe',
  customRemoveFromTeam: 'Removido da equipa',
  customEditTeam: 'Editar Equipe',
  customMember: 'Membro',
  customMemberName: 'Nome do membro',
  customAddNewMember: 'Adicionar um membro',
  customNumberOfMember: 'Número de membros',
  customInviteMembers: 'Convidar membros',
  customSendInvitationEmail: 'Enviar e-mail de convite',
  customPleaseEnterTheNameOfTheMember: 'Por favor, digite os nomes dos membros que você está convidando',
  customMemberList: 'Lista de Membros',
  customEditMember: 'Editar Membro',
  customInviting: 'Durante um convite',
  customRestrictFollow: 'Seguir restrição',
  customPermission: 'Direitos de acesso',
  customPermissionName: 'Nome da autorização de acesso',
  customRoleName: 'Nome do papel',
  customAction: 'Ação',
  customIndividualCreation: 'Criação Individual',
  customConfirmTeamDeletion: 'Posso remover esta equipa?',
  customConfirmMemberRemovalFromTeam: 'Posso remover este membro da equipa?',
  customSelectTeamsForMemberToJoinDialogTitle: 'Seleccionar equipas a que o membro se vai juntar',
  customSelectTeamsForMemberToJoinDialogOK: 'Adicionar à equipa seleccionada',
  customSelectMembersAddToTeamDialogTitle: 'Por favor, selecione os membros para fazer parte da equipe',
  customSelectMembersAddToTeamDialogOK: 'Adicionar os membros selecionados',
  customFollowMembersDialogTitle: 'Por favor selecione um membro a seguir',
  customFollowMembersDialogOK: 'Siga o membro selecionado',
  customTeamFollowSelectDialogTitle: 'Por favor, selecione uma equipe a seguir',
  customTeamFollowSelectDialogOK: 'Seguir as equipas seleccionadas',
  customPleaseConfirm: 'Por favor, verifique.',
  customEnterpriseSignUpForPleaseConfirmDescription1:
    'O usuário com o endereço de e-mail especificado está no Plano Padrão ou Enterprise.',
  customEnterpriseSignUpForPleaseConfirmDescription2:
    'Se tiver um Plano Padrão, por favor inscreva-se num plano Enterprise depois de o ter cancelado.',
  customEnterpriseSignUpForFreePlanDescription:
    'Os usuários com o endereço de e-mail especificado estão em um plano gratuito. Posso mudar para o plano Enterprise?',
  customEnterpriseSignUpForStandardPlanDescription:
    'O utilizador com o endereço de correio electrónico especificado cancelou o seu plano Standard, mas este ainda está activo. Quer mudar para o plano Enterprise? (Note-se que se o utilizador ainda deve pelo plano Standard, será cobrado tanto pelo plano Standard como pelo plano Enterprise.)',
  customAddFollowMembers: 'Adicione um membro seguinte',
  customAddFollowTeams: 'Adicione uma equipe de acompanhamento',
  customBillingMaxMember: 'Número máximo de membros',
  customCreditCardRegistration: 'Registro de Cartão de Crédito',
  customNext: 'Próximo',
  customGoBackOneStep: 'Voltar ao anterior',
  customRestriction: 'Restrição',
  customMemberSuspension: 'Tens a certeza que queres parar de usar este membro?',
  customResumeMemberUsage: 'Tem a certeza que quer voltar a usar este membro?',
  customRestart: 'Reinicie',
  customSuspended: 'Suspenso',
  customAddToExistingTeam: 'Adicionar à equipe',
  customFollowFunction: 'Função de acompanhamento',
  customAllowToAddAndRemoveFollow: 'Permitir adicionar e remover os seguintes',
  customAllowToAddAndRemoveFollowDescription:
    'Este membro não está autorizado a adicionar ou remover seguidores por conta própria.',
  customNotAllowToAddAndRemoveFollow: 'Não permitir adicionar e remover os seguintes',
  customNotAllowToAddAndRemoveFollowDescription: 'Este membro é livre para adicionar e remover seguidores.',
  customEnterprisePlanDisplayName: 'Plano da empresa',
  customPricePerMember: 'Preço por membro.',
  customPerMember: 'Por membro',
  customNotesOnPlanSelection: 'O valor faturado é o número máximo de membros no mês de faturamento x preço unitário.',
  customDueDateForFirstRepayment: 'Data de vencimento do primeiro reembolso',
  customEnterprisePlanStart: 'Início',
  customUnsubscribeFromEnterprise: 'Cancelar a inscrição no Plano Empresarial',
  customReturnAgriBusWeb: 'Retornar à Agri-Bus Web',
  customAboutCreditCardPayment: 'Sobre o pagamento com cartão de crédito',
  customClickHereUnsubscripbeFromEnterprise: 'Clique aqui para cancelar a inscrição no Plano Empresarial.',
  customEnterpriseWithdrawText1:
    'Devido à retirada da filiação, a conta deste mês será a última deste mês e não serão feitos mais pagamentos.',
  customEnterpriseWithdrawText2:
    'Continuaremos a desenvolver cada produto da série AgriBus no futuro, portanto, se você tiver uma chance, por favor, dê uma olhada novamente.',
  customEnterpriseWithdrawText3:
    'Gostaríamos de agradecer por utilizar cada um dos produtos da série AgriBus, mesmo que tenha sido apenas por um momento. Obrigado por seu interesse em nossos produtos.',
  customErrorEnterpriseWithdraw: 'Você falhou em cancelar seu plano Enterprise. Por favor, tente novamente.',
  customGuidanceInterval: 'intervalo de orientação',
  customWorkingWidth: 'largura de trabalho',
  customRefLineLength: 'comprimento da Linha de Orientação',
  customRefLine: 'linha de referência',
  customExportRefLine: 'Exportando uma linha de base',
  customDirecton: 'direção',
  customShowTaskDetailError:
    'Não há histórico de trabalho; pode ter ficado fora de sincronia com o AgriBus-NAVI ou apagado.',
  customFileUploadAttributeNameForRefLineName: 'Nome do atributo a ser usado como linha de base',
  customFileUploadRefLineImportStart: 'Comece a tomar em {count} linhas de referência.',
  customFileUploadShapefileDescriptionForRefLines:
    'O Shapefile requer um arquivo zip (comprimido) somente para os seguintes arquivos',
  customFileUploadShpDescriptionForRefLines: 'Swaths.shp (Informações topográficas)',
  customFileUploadShxDescriptionForRefLines: 'Swaths.shx (informação do índice)',
  customFileUploadDbfDescriptionForRefLines: 'Swaths.dbf (informação de atributos)',
  customRefLineImportFinishedMessage: 'Conseguimos capturar {count} linhas de referência.',
  customRefLineImportErrorMessage: 'Eu não consegui capturar uma linha de base.',
  customRefLineAddTitle: 'Registro da nova linha de referência',
  customRefLineImportTitle: 'Carregamento de arquivos de forma',
  customRefLineImportText: 'Faça o upload de seu shapefile',
  customRefLineImportText2: 'Somente linhas de referência de saída da Trimble CFX-750 podem ser importadas.',
  customRefLineCreateTitle: 'Criar uma linha base em um mapa',
  customRefLineCreateText: 'Criar uma linha base no mapa',
  customRefLineUploadTitle: 'Carregando uma linha de base',
  customRefLineNameHint: 'nome da linha de referência',
  customRefLineDeleteAlert: 'Você tem certeza de que quer apagar o {refLineName}?',
  customRefLineDeleteUnknownName: 'Esta linha de referência',
  customRefLineDeleteKnownName: 'Linha de referência "{refLineName}".',
  customRefLineDeleteError: 'Falha ao apagar a linha de referência.',
  customThunderstormWithLightRain: 'Tempestade com chuva leve',
  customThunderstormWithRain: 'Tempestade com chuva',
  customThunderstormWithHeavyRain: 'Tempestade com chuva forte',
  customThunderstormWithLightDrizzle: 'Tempestade com leve garoa',
  customThunderstormWithDrizzle: 'Tempestade com chuvisco',
  customThunderstormWithHeavyDrizzle: 'Trovoada com fortes chuviscos',
  customThunderstormWithHail: 'Tempestade de trovoada com granizo',
  customLightDrizzle: 'Drizzle leve',
  customDrizzle: 'Drizzle',
  customHeavyDrizzle: 'Drizzle pesado',
  customLightRain: 'Chuva leve',
  customModerateRain: 'Chuva moderada',
  customHeavyRain: 'Chuva forte',
  customFreezingRain: 'Chuva gelada',
  customLightShowerRain: 'Chuva leve',
  customShowerRain: 'Chuva de chuva',
  customHeavyShowerRain: 'Chuva forte',
  customLightSnow: 'Neve leve',
  customSnow: 'Neve',
  customHeavySnow: 'Neve Pesada',
  customMixSnowRain: 'Misturar neve/comboio',
  customSleet: 'Sleet',
  customHeavySleet: 'Pesado',
  customSnowShower: 'Chuveiro de neve',
  customHeavySnowShower: 'Chuveiro de neve pesado',
  customFlurries: 'Flurries',
  customMist: 'Névoa',
  customSmoke: 'Fumo',
  customHaze: 'Perigo',
  customSandDust: 'Areia/pó',
  customFog: 'Fog',
  customFreezingFog: 'Névoa Congelada',
  customClearSky: 'Céu limpo',
  customFewClouds: 'Poucas nuvens',
  customScatteredClouds: 'Nuvens dispersas',
  customBrokenClouds: 'Nuvens quebradas',
  customOvercastClouds: 'Nuvens encobertas',
  customUnknownPrecipitation: 'Precipitação desconhecida',
  customWeatherInfoTitle: 'Informações meteorológicas',
  customWeatherDescriptionTitle: 'tempo',
  customWindSpeedTitle: 'velocidade do vento',
  customTemperatureTitle: 'temperatura',
  customRelativeHumidityTitle: 'nível de humidade',
  customNumOfSatellites: 'número de satélites',
  customGnssStatus: 'Status do GNSS',
  customLeftRightMisalignment: 'desalinhamento',
  customAzimuthShift: 'turno de azimute',
  customGradient: 'gradiente',
  customTimeOfAcquisition: 'tempo de aquisição',
  customWorkOverview: 'visão geral do trabalho',
  customImageStorage: 'armazenamento de imagens',
  customMapGaugeDescriptionNone: 'O preenchimento do trabalho sem codificação por cores é exibido',
  customMapGaugeDescriptionHeight: 'A diferença de altura do trabalho é exibida por cor',
  customMapGaugeDescriptionSpeed: 'A velocidade do trabalho é exibida por cor',
  customMapGaugeDescriptionNumOfSatellites:
    'O número de satélites de posicionamento no momento da operação é exibido em diferentes cores',
  customMapGaugeDescriptionGnssStatus: 'O status do GNSS no momento do trabalho é exibido por cor.',
  customMapGaugeDescriptionLeftRightMisalignment:
    'O desvio esquerda-direita da orientação durante a operação é exibido por cor.',
  customMapGaugeDescriptionAzimuthShift:
    'Exibição do desalinhamento com código de cores com orientação durante a operação',
  customMapGaugeDescriptionGradient:
    'A inclinação no trabalho é exibida em cores diferentes (G2, GMiniR, Gmini apenas).',
  customPrecipitationTitle: 'Precipitação',
  customWeathercomTornado: 'Tornado',
  customWeathercomTropicalStorm: 'Tempestade Tropical',
  customWeathercomHurricane: 'Furacão',
  customWeathercomStrongStorms: 'Tempestades Fortes',
  customWeathercomThunderstorms: 'Tempestades',
  customWeathercomRainSnow: 'Neve Chuva',
  customWeathercomRainSleet: 'Carro de Chuva',
  customWeathercomWintryMix: 'Mistura invernal',
  customWeathercomFreezingDrizzle: 'Congelamento Drizzle',
  customWeathercomDrizzle: 'Drizzle',
  customWeathercomFreezingRain: 'Chuva Congelada',
  customWeathercomShowers: 'Chuveiros',
  customWeathercomRain: 'Chuva',
  customWeathercomFlurries: 'Flurries',
  customWeathercomSnowShowers: 'Chuveiros de Neve',
  customWeathercomBlowingDriftingSnow: 'Neve à deriva',
  customWeathercomSnow: 'Neve',
  customWeathercomHail: 'Salve',
  customWeathercomSleet: 'Sleet',
  customWeathercomBlowingDustSandstorm: 'Tempestade de poeira soprada',
  customWeathercomFoggy: 'Foggy',
  customWeathercomHaze: 'Haze',
  customWeathercomSmoke: 'Fumo',
  customWeathercomBreezy: 'Breezy',
  customWeathercomWindy: 'Windy',
  customWeathercomFrigidIceCrystals: 'Cristais de Gelo Frigido',
  customWeathercomCloudy: 'Nublado',
  customWeathercomMostlyCloudy: 'Principalmente nublado',
  customWeathercomPartlyCloudy: 'Parcialmente Nublado',
  customWeathercomClear: 'Limpar',
  customWeathercomSunny: 'Sunny',
  customWeathercomFairMostlyClear: 'Bastante claro',
  customWeathercomFairMostlySunny: 'Bastante ensolarado',
  customWeathercomMixedRainandHail: 'Chuva e Granizo Mistos',
  customWeathercomHot: 'Quente',
  customWeathercomIsolatedThunderstorms: 'Tempestades Isoladas',
  customWeathercomScatteredThunderstorms: 'Tempestades Dispersas',
  customWeathercomScatteredShowers: 'Chuveiros Espalhados',
  customWeathercomHeavyRain: 'Chuva forte',
  customWeathercomScatteredSnowShowers: 'Chuveiros de Neve Espalhados',
  customWeathercomHeavySnow: 'Neve Pesada',
  customWeathercomBlizzard: 'Blizzard',
  customWeathercomNotAvailable: 'Não Disponível',

  customSharedMountPointSetting: 'Ajuste do ponto de montagem',
  customSharedMountPointSettingTitle:
    'Definir o ponto de montagem da estação de referência RTK para ser compartilhado dentro da organização.',
  customSharedMountPoint: 'ponto de montagem compartilhado',
  customMountPoint: 'ponto de montagem',
  customStatus: 'status',
  customNotSet: 'Não está definido.',
  customSelectMountPoint: 'Selecione o ponto de montagem',
  customUnsharedMountPoint: 'Não compartilhado',
  customSelectMountPointTitle: 'Selecione o ponto de montagem para compartilhar',
  customSharedMountPointRemarks1:
    'Os pontos de montagem são emitidos quando o AgriBus-GMiniR é definido como uma estação de referência usando a aplicação AgriBus-GTools. Se você estiver usando uma estação de referência de outro fabricante, por favor, aplique a partir do link abaixo.',
  customSharedMountPointRemarks2: 'Clique aqui para candidatar-se.',
  customOnline: 'online',
  customOffline: 'off-line',
  customNotIssued: 'não emitido',
  customSetItUp: 'Estamos prontos.',
  customDeActivated: 'Desativado.',
  customType: 'classificação',
  customCropIsNotRegistered: 'A safra não está registrada.',
  customNameNotRegistered: 'Nome Não Registrado',

  customGoToPayerManager: 'Abrir a página de administração',
  customPaymentInfo: 'Informações sobre pagamento',
  customProjectInfo: 'Informações sobre o projeto',
  customAddProject: 'Adicionar Projeto',
  customAddProjectRemarks: 'Favor especificar o nome do projeto e o endereço de e-mail do administrador',
  customProjectName: 'Nome do projeto',
  customProjectAdminMailAddress: 'E-mail do administrador',
  customStop: 'suspensão',
  customStopDialogText: 'Você deseja excluir o projeto selecionado?',
  customDone: 'Está feito.',
  customUpdateDay: 'data de atualização',
  customAdminName: 'Nome do gerente',
  customMaxQuantity: 'número máximo de pessoas',
  customaddProjectSuccess: 'Seu projeto foi adicionado.',
  customPlantingShowPast: 'Mostrar plantios passados',
  customPlantingHidePast: 'Ocultar plantios anteriores',
  customPlantingCropDisplayName: 'nome de exibição da cultura',
  customPlantingCropVarietyName: 'Nome da Variedade',
  customPlantingSeason: 'Época de crescimento',
  customPlantingSeasonStartDate: 'Data de início (obrigatório)',
  customPlantingSeasonEndDate: 'Data de fim',
  customPlantingAddCropOption: 'Adicionar opção de cultura',
  customPlantingRemoveCropOption: 'Remove crop option',
  customPlantingCropSelectionRequiredError:
    'Deve seleccionar esta opção. Se nenhuma se aplicar, seleccione por favor "Outra".',
  customPlantingOtherCropSelectionRequiredError: 'Deve ser introduzido se tiver seleccionado "Outro"',
  customPlantingDeleteConfirmationMessage:
    'Tem a certeza de que quer apagar {plantingName}? (quaisquer dados associados serão também apagados)',
  customPlantingFieldSelectionHint: 'Se o nome do talhão não estiver definido, não aparecerá na lista aqui',

  customTaskDeleteMessage: 'Você tem certeza de que deseja apagar o trabalho selecionado?',
  customTaskDeleteFailure: 'Falha em excluir o trabalho selecionado',
  customTaskDeleteSucceed: 'Você eliminou com sucesso o trabalho selecionado',

  customErrorStartDateRequired: 'Data de início é necessária',
  customErrorFieldRequired: 'As parcelas são essenciais',

  customAlreadyExistingUser:
    'Você já registrou seu endereço de e-mail. Por favor, use um endereço de e-mail não-registrado.',

  customNowProgressRateTitle: 'Progresso do trabalho',
  customNowProgressRateNotField: 'Não há parcelas relevantes',

  customStandardSubscribeErrorMessage:
    'Sua compra de assinatura falhou. Por favor, verifique novamente as informações que você inseriu.',
  customStripeCouponText1: 'Clique aqui para resgatar seu voucher',
  customStripeCouponText2: 'Clique aqui para obter o código do voucher',

  customUpdatePolygonFailure: 'Não consegui atualizar minhas parcelas.',

  customMultiPolygonImportError:
    'Dados contendo MultiPolygons, que devem ser convertidos em Polígonos, pois MultiPolygons não são suportados.',

  customSimpleSignUpAndSignInError: 'Há um problema com seu endereço de e-mail ou senha. Por favor, verifique.',
  customNewPasswordValidationError: 'Pelo menos uma letra minúscula e um número são necessários.',

  // 2022.12.08
  customSelectPlanSelectPaymentMethodText: 'Selecione uma forma de pagamento',
  customCardInfoHasNotBeenEnteredError: 'Por favor, digite os detalhes de seu cartão',
  customNoPaymentMethodSeletedError: 'Nenhuma forma de pagamento selecionada.',
  customFreeDashBoardText1: 'Para entrar na AgriBus-Web, é necessário assinar o plano pago (AgriBus Professional).',
  customFreeDashBoardText2: 'Veja mais informações.',
  customFreeDashBoardText3: 'Aviso.',
  customFreeDashBoardText4: '',
  customContractPlanTitle: 'Plano de contrato',
  customComparePlansText: 'Compare os planos',
  customUpgradeToPlusText: 'Atualização para Plus',
  customDowngradeToPlusText: 'Desclassificação para Plus.',
  customUpgradeToProfessionalText: 'Atualização para AgriBus Professional',
  customBillingBillingText1: 'Cancelado - automaticamente convertido em um plano Livre quando expira.',
  customUpgradeConfirematoinText: 'Vou me atualizar para AgriBus Professional. Está tudo bem com você?',
  customDowngradeConfiremationText: 'Desceremos para a categoria Plus. Posso?',
  customBankTransfer: 'transferência bancária',
  customHome: 'Início',
  customBillingMessageSubscribeGoogle:
    'Está actualmente subscrito na Loja Play do Google; por favor actualize/baixe a sua subscrição na Loja Play do Google',
  customInvoiceReceiptAddresseeTitle: 'Endereço da fatura/recibo',
  customChangeAddresseeBtnText: 'Alterar o endereço.',
  customBillingEmailAddressTitle: 'Endereço de e-mail para faturamento',
  customChangeBillingEmailAddressText: 'Altere seu endereço de e-mail de cobrança',
  customCannotDowngradeText: 'As transferências bancárias não podem ser rebaixadas para Plus.',
  customChangePaymentMethodsToCard: 'Mudança para pagamento com cartão',
  customChangePaymentMethodsToCustomerBalance: 'Mudança para transferência bancária',
  customChangePaymentMethodToSendInvoiceText: 'Posso mudar meu método de pagamento para transferência bancária?',
  customMapGaugeDescriptionColorCodedFill:
    'Se o aplicativo tiver sido pintado por cores, será exibido um histórico de trabalho codificado por cores.',
  customColorCodeFill: 'Preencher por cor',
  customSelectDefaultIconTitle: 'Selecione um ícone',
  customImportLimitMessage: 'O número máximo de importações é {limit}.',
  customPresetIcon: {
    title: 'Predefinição',
    description: 'Escolha entre seis predefinições diferentes.',
    btnText: 'Selecione entre as predefinições',
  },
  customBulkDeleteCheckboxText: 'exclusão em massa',
  customBulkDeleteDialogText: 'Posso fazer uma exclusão em massa?',
  customPerimeter: 'Perímetro',
  feed: {
    menu: 'Feed',
    title: 'Feed de notícias',
    description: 'Estatísticas diárias (anônimas) da atividade agrícola regional e novidades das regiões produtoras.',
    yourArea: 'Atividade na sua área (~33 km)',
    areaFromFields: 'Detectado pelos seus talhões',
    widerArea: 'Área ampliada (~55 km)',
    national: 'Atividade nacional',
    daily: 'Ontem',
    weekly: 'Últimos 7 dias',
    monthly: 'Últimos 28 dias',
    vsNormal: 'vs normal',
    vsLastYear: 'vs ano passado',
    noData: 'Dados insuficientes nesta área (poucas operações próximas).',
    noAreaHint: 'Cadastre seus talhões para ver as estatísticas da sua área.',
    nationalFallback: 'As estatísticas nacionais são mostradas abaixo.',
    upsell: 'Planos pagos adicionam as janelas diária e de 28 dias, além da visão ampliada de ~55 km.',
    monitorTitle: 'Boletim semanal do monitor',
    monitorActive: 'Padrão de observação ativo',
    monitorNone: 'Sem padrão de observação',
    toMarketInsights: 'Abrir Market Insights',
    loadError: 'Não foi possível carregar o feed. Tente novamente mais tarde.',
    disclaimer: 'A atividade regional é uma estatística anônima, não uma avaliação de fazendas individuais.',
    kindNews: 'Notícias',
    kindPr: 'PR',
    readMore: 'Saiba mais',
    entryDaily: 'Atividade de trabalho em {date}',
    entryWeekly: 'Resumo semanal (até {date})',
    areaC3: 'Sua área',
    areaC5: 'Área ampla',
    areaJp: 'Nacional',
    historyTitle: 'Tendência histórica',
    kindSignal: 'Sinal',
    shareTitle: 'Compartilhar no feed',
    share: 'Compartilhar',
    shareVisibility: 'Visibilidade',
    visFollowers: 'Somente seguidores',
    visNeighborhood: 'Vizinhança',
    visPublic: 'Público',
    shareRoute: 'Mostrar trajeto de trabalho',
    shareExact: 'Compartilhar localização exata (fundo de mapa)',
    statTime: 'Tempo',
    statDistance: 'Distância',
    statArea: 'Área',
    statWidth: 'Largura',
    statSpeed: 'Velocidade',
    statGnss: 'GNSS',
    shareComment: 'Comentário',
    shareSubmit: 'Compartilhar',
    sharePosted: 'Compartilhado',
    shareFailed: 'Não foi possível concluir. Tente novamente mais tarde.',
    consentNote:
      'Sua publicação é exibida aos usuários do alcance selecionado. A localização é mostrada apenas como área aproximada (cerca de 11 km).',
    consentLabel: 'Concordo com os termos de compartilhamento (art. 15-2)',
    postDelete: 'Excluir',
    postDeleted: 'Publicação excluída',
    postDeleteConfirm: 'Excluir esta publicação?',
    report: 'Denunciar',
    reportTitle: 'Denunciar publicação',
    reportConfirm: 'Denunciar esta publicação ao operador?',
    reportReason: 'Motivo (opcional)',
    reportDone: 'Denúncia enviada. Obrigado',
    visPrivate: 'Somente eu',
    followRequested: 'Solicitado',
    followAccept: 'Aceitar',
    followDecline: 'Recusar',
    followAccepted: 'Pedido de seguir aceito',
    unfollow: 'Deixar de seguir',
    unfollowConfirm: 'Deixar de seguir este usuário?',
    connectionsHint:
      'Envie pedidos de seguir a partir das publicações do feed. Depois de aceitos, verá publicações exclusivas para seguidores',
    sharePhotos: 'Adicionar fotos (até 4)',
    sharePhotosHint: 'Metadados de localização (EXIF) são removidos automaticamente',
    snsShare: 'Compartilhar',
    copyLink: 'Copiar link',
    linkCopied: 'Link copiado',
    shareOther: 'Outros aplicativos',
    instagramSaved: 'Imagem salva. Publique pelo aplicativo do Instagram',
    manualRecords: 'Registros manuais',
    addManualRecord: 'Adicionar registro manual',
    manualChip: 'Manual',
    recordStart: 'Inicio',
    recordEnd: 'Fim',
    recordMemo: 'Nota',
    recordDuration: 'Duração (min)',
    recordCreated: 'Registro adicionado',
    recordDeleteConfirm: 'Excluir este registro?',
    noManualRecords: 'Ainda não há registros manuais',
    poiRecords: 'Pontos de interesse',
    addPoi: 'Adicionar ponto de interesse',
    poiTitle: 'Titulo',
    poiMapHint: 'Clique no mapa para definir o ponto. Caso contrário, a localização da foto será usada',
    noPoiRecords: 'Ainda não há pontos de interesse',
    map: 'Mapa',
    mapLayers: 'Camadas',
    editMode: 'Modo de edição',
    selected: 'Selecionadas',
    mergeSave: 'Salvar mesclado',
    clipDraw: 'Desenhar área de recorte',
    saveAsField: 'Salvar área plantada como talhão',
    workWidthM: 'Largura de trabalho (m)',
    workName: 'Nome',
    workSaved: 'Registro derivado salvo',
    derivedRecords: 'Registros derivados',
    derivedChip: 'Derivado',
    derivedDeleteConfirm: 'Excluir este registro derivado?',
    saveRangeAsWork: 'Salvar intervalo selecionado como registro derivado',
    clipByField: 'Recortar por talhão',
    showOnMap: 'Mostrar no mapa',
    editRange: 'Editar intervalo',
    trajectoryChip: 'GPS',
    derivedRecordsDescription:
      'Registros de trabalho pareados 1:1 com cada trajetória. Registros editados e manuais também aparecem aqui',
    spatialEdit: 'Recortar / Salvar talhão',
    vraTitle: 'Mapa VRA',
    vraDescription: 'Gere mapas de zonas para aplicação em taxa variável a partir de índices de vegetação por satélite',
    vraGenerate: 'Gerar novo mapa',
    vraIndex: 'Índice de vegetação',
    vraGridSize: 'Grade (m)',
    vraDirection: 'Direção (graus)',
    vraCloudPct: 'Nuvens máx. (%)',
    vraImages: 'Imagens usadas',
    vraFailed: 'Falha na geração. Pode não haver imagens sem nuvens no período',
    saveFailed: 'Falha ao salvar',
    mapSetGenerated: 'Geração concluída',
    fieldValidFromDate: 'Válido desde: {date}',
    fieldDeleteLinked: '{fieldName} não pode ser excluído porque está vinculado aos seguintes dados.',
    fieldDeleteLinkedTasks: 'Registros de trabalho: {count}',
    fieldDeleteLinkedSets: 'Conjuntos de campos: {names}',
    fieldDeleteLinkedHint: 'Para excluir, primeiro remova os registros de trabalho e conjuntos vinculados.',
    elevSource: 'Fonte',
    elevSourceDem: 'Satélite (DEM)',
    elevSourceGnss: 'Histórico de trabalho (GNSS)',
    elevCenter: 'Centro de cor',
    elevCenterMean: 'Média',
    elevCenterMedian: 'Mediana',
    elevCenterValue: 'Elevação central',
    elevCustom: 'Personalizado',
    elevRange: 'Faixa de cor',
    elevRangeWidth: 'Largura da faixa',
    elevContour: 'Curvas de nível',
    zoneBands: 'Zonas',
    zonePalette: 'Color scheme',
    paletteHue: 'HSI (green→yellow→red)',
    paletteYlgn: 'Yellow→Green',
    paletteGnrd: 'Green→Red',
    reclassifyTitle: 'Alterar zonas/cores (sem regenerar)',
    reclassifyApply: 'Aplicar reclassificação',
    followByEmail: 'Solicitação de seguir por e-mail',
    emailUserNotFound: 'Nenhum usuário encontrado para este e-mail',
    followRequestSent: 'Solicitação de seguir enviada',
    eventSettingsTitle: 'Feed settings (auto events)',
    eventSettingsVisibility: 'Event visibility',
    eventSettingsLocation: 'Location visibility',
    eventSettingsSnsStrip: 'Strip exact location when sharing to SNS (default)',
    eventSettingsPrefs: 'Events posted to your feed',
    locHidden: 'Hidden',
    locApprox: 'Approximate (~10 km grid)',
    locExact: 'Include exact location',
    event_work_start: 'Work started',
    event_work_end: 'Work finished',
    event_field_enter: 'Entered field',
    event_field_exit: 'Left field',
    event_poi_added: 'POI added',
    event_vra_map_added: 'VRA map added',
    event_elevation_map_added: 'Height map added',
    event_refline_added: 'Guidance line added',
    event_field_added: 'Field added',
    event_field_set_added: 'Field set added',
    event_work_start_text: 'started working ({name})',
    event_work_end_text: 'finished working ({name})',
    event_field_enter_text: 'entered field \u201c{name}\u201d',
    event_field_exit_text: 'left field \u201c{name}\u201d',
    event_poi_added_text: 'added POI \u201c{name}\u201d',
    event_vra_map_added_text: 'created VRA map \u201c{name}\u201d',
    event_elevation_map_added_text: 'created height map \u201c{name}\u201d',
    event_refline_added_text: 'added guidance lines ({name})',
    event_field_added_text: 'added field \u201c{name}\u201d',
    event_field_set_added_text: 'created field set \u201c{name}\u201d',
    vraNameAuto: 'Nome (vazio = automático)',
    eventPrefOff: 'Do not post',
    visEditTitle: 'Change visibility',
    visEditLocationExact: 'Show exact location (map background)',
    visEditRemoveLocation: 'Remove exact location',
    visEditPublicNote: 'Exact location is automatically excluded for public posts',
    consentRequiredToShare: 'Sharing requires consent to the sharing terms. Enable sharing from a regular post first',
    elevGnssFailed:
      'Falha no cálculo de desnível. Nenhum histórico de trabalho (elevações GNSS) corresponde aos filtros, ou ainda está em processamento. Tente relaxar o filtro GNSS ou o intervalo de datas',
    elevDescription:
      'Gere mapas de desnível a partir de elevações GNSS do histórico de trabalho (RTK recomendado). Sem histórico, dados de satélite (DEM) também podem ser usados. Sincroniza com o NAVI como os mapas VRA',
    fieldValidUntil: 'Válido até: {date}',
    mapSetGeneratedWithCount:
      'Gerados {created} / falhas {failed} (os mapas existentes dos mesmos talhões são substituídos)',
    vraGenerating: 'Analisando imagens de satélite...',
    vraObsDate: 'Data de observação',
    vraPeriodMean: 'Média do período',
    vraLimitReached: 'Limite de geração atingido (Free: 3 no total, planos pagos: 10 por dia)',
    vraExport: 'Exportar ISOXML',
    vraModeGrid: 'Malha (grade)',
    vraModePolygon: 'Polígono',
    vraRate: 'Taxa de aplicação (kg/ha)',
    vraCellSize: 'Tamanho da célula (m)',
    vraEditMap: 'Editar',
    mapSets: 'Conjuntos de talhões',
    mapSetDescription:
      'Agrupe talhões com um filtro (período de validade, cultura, nome). Usado para gerar mapas VRA em lote',
    mapSetCreate: 'Criar conjunto de talhões',
    fieldSetEmpty: 'Ainda não há conjuntos de talhões',
    mapSetTargetDate: 'Data alvo',
    mapSetCrop: 'Cultura',
    mapSetNameContains: 'Nome (contém)',
    mapSetMemoContains: 'Memo (contém)',
    mapSetPreviewCount: 'Talhões correspondentes',
    mapSetGenerate: 'Gerar/Atualizar',
    mapSetFields: 'Talhões',
    mapSetLastGenerated: 'Última geração',
    fieldAttrsTitle: 'Atributos do talhão (vigência e cultura)',
    fieldValidFrom: 'Válido de (vazio = ilimitado)',
    fieldValidTo: 'Válido até (vazio = ilimitado)',
    mapSetNoMatch: 'Nenhum talhão corresponde ao filtro',
    mapSetDeleteConfirm: 'Excluir este conjunto de talhões e os mapas VRA gerados a partir dele?',
    trajectories: 'Trajetórias',
  },
  marketInsights: {
    menu: 'Informações de Mercado',
    title: 'Informações de Mercado (AgriBus-DWH)',
    description:
      'Acompanhe diariamente o progresso dos trabalhos e as observações de mercado das principais regiões produtoras de soja e trigo do mundo. É um benefício do assinante: estatísticas anônimas construídas a partir dos dados de trabalho dos membros, entregues como informação útil, por exemplo, para decidir quando vender.',
    soybeanDescription: 'Situação das lavouras e sinais de mercado das regiões de soja do Brasil e dos EUA',
    wheatDescription: 'Situação das lavouras e sinais de mercado das regiões de trigo',
    open: 'Abrir',
    upsell:
      'As Informações de Mercado são um benefício para assinantes de planos pagos. Com um plano pago, você pode visualizá-las sem custo adicional.',
    memberNote:
      'Ao visualizar como assinante, um selo aparece no canto superior esquerdo do monitor. Estas informações não são recomendação de investimento.',
  },
}
